module.exports = __webpack_public_path__ + "media/images/emblems/Inden_VS-5f8aef5e0ac051281d7816a60482cecb.png";